import styled from '@emotion/styled';
import { theme } from 'app/theme';

// padding-bottom checks for nullish value (null or undefined), hence not !==
export const PageBanner = styled('div')`
    margin-top: -${theme.styles.header.height};
    padding-top: ${theme.styles.header.height};
    padding-bottom: ${(props) => (props.sx?.paddingBottom != null ? props.sx?.paddingBottom : '45px')};
    overflow: ${(props) => (props.industries ? 'visible' : 'hidden')};
    min-height: 220px;
    position: relative;
    background: #fff;
    color: #fff;
`;
